import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { appFeedback } from '@/shared/feedback/appFeedback';

/**
 * Registers the app's service worker (workbox-precached shell, see src/sw/firebase-messaging-sw.js)
 * and surfaces a reload prompt when a new build has been deployed. registerType is 'prompt', not
 * 'autoUpdate' — silently swapping JS under a user mid-session risks a stale-vs-fresh chunk
 * mismatch, so the new SW waits until this confirms. Mount once (in AppShell).
 */
export function useServiceWorkerUpdate() {
  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW({
    onRegisterError(error) {
      console.error('[pwa] service worker registration failed:', error);
    },
  });

  useEffect(() => {
    if (!needRefresh) return;
    appFeedback.notification('info', 'Bản cập nhật mới', 'Đã có phiên bản mới của dashboard. Tải lại để cập nhật.', { key: 'pwa-update', duration: 0, onClick: () => void updateServiceWorker(true) });
  }, [needRefresh, updateServiceWorker]);
}
